<div class="login-screen">
  <aside class="login-brand">
    <div class="login-brand__ring login-brand__ring--tr-lg"></div>
    <div class="login-brand__ring login-brand__ring--tr-sm"></div>
    <div class="login-brand__ring login-brand__ring--bl-lg"></div>
    <div class="login-brand__ring login-brand__ring--bl-sm"></div>

    <div class="login-brand__top">
      <div class="login-logo">
        <span class="login-logo__pill">
          <span class="login-logo__mark">Mechanics in Motion</span>
          <span class="login-logo__by">by Egitura</span>
        </span>
      </div>
    </div>

    <div class="login-brand__center">
      <div class="login-brand__statement">
        <p class="login-brand__slogan">
          <span class="login-brand__slogan-quote">&ldquo;</span>Empowerment<br />through
          <em class="login-brand__slogan-accent">awareness</em
          ><span class="login-brand__slogan-quote">&rdquo;</span>
        </p>
      </div>

      <div class="login-brand__projects">
        <div class="login-brand__projects-title">Projects taking root</div>
        <ul class="login-brand__project-list">
          <li class="login-brand__project">
            <span class="login-brand__project-icon"><i eIcon icon="atom"></i></span>
            <span class="login-brand__project-text">
              <span class="login-brand__project-name">Human by Design</span>
              <span class="login-brand__project-sub">The Mechanics of Human Design</span>
            </span>
          </li>
          <li class="login-brand__project">
            <span class="login-brand__project-icon"><i eIcon icon="wind"></i></span>
            <span class="login-brand__project-text">
              <span class="login-brand__project-name">The Breathing Mechanic</span>
              <span class="login-brand__project-sub">rediscover the art of breathing less</span>
            </span>
          </li>
          <li class="login-brand__project">
            <span class="login-brand__project-icon"><i eIcon icon="child"></i></span>
            <span class="login-brand__project-text">
              <span class="login-brand__project-name">Zo zit je in mekaar (BE/NL)</span>
              <span class="login-brand__project-sub">Human Design voor kinderen &amp; ouders</span>
            </span>
          </li>
          <li class="login-brand__project">
            <span class="login-brand__project-icon"><i eIcon icon="feather-alt"></i></span>
            <span class="login-brand__project-text">
              <span class="login-brand__project-name">Blog</span>
              <span class="login-brand__project-sub">A 6th line transmission</span>
            </span>
          </li>
        </ul>
      </div>
    </div>

    <div class="login-brand__bottom">
      <div class="login-brand__collab">
        <div class="login-brand__collab-title">{{ 'account.login.collab.title' | transloco }}</div>
        <p class="login-brand__collab-text">
          {{ 'account.login.collab.text' | transloco }}
        </p>
        <a class="login-brand__collab-link" href="mailto:collab@mechanicsinmotion.be">
          <i eIcon icon="envelope"></i>
          collab&#64;mechanicsinmotion.be
        </a>
      </div>

      <div class="login-brand__divider"></div>
      <div class="login-brand__footer">
        <div class="login-brand__version">
          <span class="login-brand__version-label">VERSION</span>
          <span class="login-brand__version-number">v{{ appService.version }}</span>
          <span class="login-brand__version-by">by Egitura</span>
        </div>
      </div>
    </div>
  </aside>

  <main class="login-main">
    <div class="login-main__tag">
      <span class="login-brand__dot login-brand__dot--online"></span>
      Mechanics in Motion · v{{ appService.version }}
    </div>

    <div class="login-card">
      <div class="login-card__language">
        <language-selector />
      </div>
      <header class="login-card__header">
        <div class="login-logo login-logo--light">
          <span class="login-logo__pill">
            <span class="login-logo__mark">Mechanics in Motion</span>
          </span>
        </div>
        <h1 class="login-card__title">{{ 'account.login.title' | transloco }}</h1>
        <p class="login-card__subtitle">{{ 'account.login.subtitle' | transloco }}</p>
      </header>

      @if (platformMode.mode() !== 'normal') {
        <div class="alert alert-warning login-card__mode" role="status">
          <i eIcon icon="lock"></i>
          {{ 'platform.mode.login.' + platformMode.mode() | transloco }}
        </div>
      }

      <div class="login-card__body">
        <login-factory (afterLogin)="onAfterLogin()"></login-factory>
      </div>

      <footer class="login-card__footer">
        <span class="login-card__trust">
          <span class="login-brand__dot login-brand__dot--online"></span>
          {{ 'account.login.secureConnection' | transloco }}
        </span>
        <span class="login-card__trust login-card__trust--muted">
          <i class="fa-solid fa-lock" aria-hidden="true"></i>
          256-bit SSL
        </span>
      </footer>
    </div>
  </main>
</div>
